import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import VoucherDetails from './VoucherDetails';

const EmployeeVouchersPage = () => {
  return (
    <Container fluid>
      <Row>
        <Col>
          <VoucherDetails />
        </Col>
      </Row>
    </Container>
  );
};

export default EmployeeVouchersPage;